import { Component } from '@angular/core';
import { CellRendererComponent } from '@valg-shared/components/table/directives/cell-component-outlet/cell-component-outlet.directive';
import { getValueAt } from "@valg-shared/utils/object-utils";
import { Column } from '@valg-shared/components/table/table/column';

@Component({
  selector: 'valg-dk-collection-renderer',
  templateUrl: './collection-renderer.component.html'
})
export class CollectionRendererComponent implements CellRendererComponent {
  value: string[] = [];

  public init(data: unknown, column: Column): void {
    let collectionProperty = column.metadata?.rendererOptions?.get('collectionProperty');
    if(typeof collectionProperty === "string"){
      let value = getValueAt(data, column.path);
      for(let element of value){
        this.value.push(getValueAt(element, collectionProperty))
      }
    }
    if (!collectionProperty) {
      this.value = getValueAt(data, column.path);
    }
  }

}
